<template>
  <div>

    <div class="col-12">
      <div class="card mb-4">

        <div style="text-align: right; ">
          <b-button variant="outline-primary" @click="toggleFullLayout" size="sm">
            <feather-icon icon="Maximize2Icon" size="12" />
          </b-button>
        </div>

        <div class="card-header">
          <h4 class="card-title">
            <span>{{ RelName }}</span>
          </h4>

          <b-col v-if="showFiltro ? false : true">
            <div style="float:right">
              <div class="DivBotaoLadoLado">
                <b-button variant="danger" @click="$router.push('../Relatorios')">
                  <span>RETORNAR</span>
                </b-button>
              </div>

              <div class="DivBotaoLadoLado">
                <b-button v-b-toggle="'collapse-filtro'" variant="primary">
                  <span>FILTROS</span>
                </b-button>
              </div>
            </div>
          </b-col>
        </div>

        <b-collapse visible id="collapse-filtro">
          <div class="card-body">

            <b-row>
              <b-col md="6" xl="3" class="mb-1">
                <b-form-group label="Data Inicial:">
                  <b-form-datepicker id="PeridoIni" locale="pr-BR" :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" today-button reset-button v-model="PeridoIni" placeholder="Selecione" :required="true" />
                </b-form-group>
              </b-col>

              <b-col md="6" xl="3" class="mb-1">
                <b-form-group label="Data Final:">
                  <b-form-datepicker id="PeridoFin" locale="pr-BR" :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" today-button reset-button v-model="PeridoFin" placeholder="Selecione" :required="true" />
                </b-form-group>
              </b-col>

              <b-col md="6" xl="3" class="mb-1">
                <b-form-group label="Data Corte:">
                  <b-form-datepicker id="DataCorte" locale="pr-BR" :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" today-button reset-button v-model="DataCorte" placeholder="Selecione" />
                </b-form-group>
              </b-col>

              <b-col md="6" xl="3" class="mb-1">
                <b-form-group label="Motivo Devoluções:">
                  <multiselect v-model="Motivo" placeholder="Selecione" label="name" track-by="code" :options="MotivoOption" :multiple="false" :taggable="false" :close-on-select="true" :option-height="50" :show-labels="false"></multiselect>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="6" xl="3" class="mb-1">
                <b-form-group label="Vendedor:">
                  <multiselect v-model="CodVend" placeholder="Selecione" label="name" track-by="code" :options="CodVendOption" :multiple="false" :taggable="false" :close-on-select="true" :option-height="50" :show-labels="false"></multiselect>
                </b-form-group>
              </b-col>

              <b-col md="6" xl="3" class="mb-1">
                <b-form-group label="Coordenador:">
                  <multiselect v-model="CodCoord" placeholder="Selecione" label="name" track-by="code" :options="CodCoordOption" :multiple="false" :taggable="false" :close-on-select="true" :option-height="50" :show-labels="false"></multiselect>
                </b-form-group>
              </b-col>

              <b-col md="6" xl="3" class="mb-1">
                <b-form-group label="Gerente:">
                  <multiselect v-model="CodGer" placeholder="Selecione" label="name" track-by="code" :options="CodGerOption" :multiple="false" :taggable="false" :close-on-select="true" :option-height="50" :show-labels="false"></multiselect>
                </b-form-group>
              </b-col>

              <b-col md="6" xl="3" class="mb-1">
                <b-form-group label="Região:">
                  <multiselect v-model="CodReg" placeholder="Selecione" label="name" track-by="code" :options="CodRegOption" :multiple="true" :taggable="false" :close-on-select="true" :option-height="50" :show-labels="false"></multiselect>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="6" xl="3" class="mb-1">
                <b-form-group label="Status Vendedor/Gerente/Coordenador:">
                  <multiselect v-model="Ativo" placeholder="Selecione" label="name" track-by="code" :options="AtivoOption" :multiple="false" :taggable="false" :close-on-select="true" :option-height="50" :show-labels="false"></multiselect>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="6" xl="12" class="mb-1">
                <div class="DivBotaoLadoLado">
                  <b-button variant="danger" type="button" @click="$router.push('../Relatorios')">
                    <span>RETORNAR</span>
                  </b-button>
                </div>
                <div class="DivBotaoLadoLado">
                  <b-button v-b-toggle="'collapse-filtro'" variant="primary" type="submit" @click="ConsultarRelatorio">
                    <span>CONSULTAR</span>
                  </b-button>
                </div>

                
                <hr>
                 <p><span>Acesso Rapido a Relatórios Complementares</span></p>
                 
                <div class="DivBotaoLadoLado">
                  <b-button variant="" type="button" @click="$router.push('../dashBoletimDiarioVendaAnalitico')">
                    <span>Boletim Diario de Vendas Analitico</span>
                  </b-button>
                </div>

                <div class="DivBotaoLadoLado">
                  <b-button variant="" type="button" @click="$router.push('../relAcompanhamentoPedido')">
                    <span>Acompanhamento Pedidos</span>
                  </b-button>
                </div>


              </b-col>
            </b-row>

          </div>
        </b-collapse>

      </div>
    </div>

    <div class="col-lg-12 col-24">
      <div class="row match-height">
        <div class="col-lg-2 col-md-3 col-6">
          <div class="card">
            <div class="card-body pb-50" style="position: relative;">
              <h4 class="fw-bolder mb-1">Dias Úteis:
                <i class="bi bi-calendar-event" style="font-size: 2rem; color: blue; float:right;"></i>
              </h4>
              <center><h4 class="fw-bolder mb-1"> {{ BoletimDiarioVendaCAB1.UTEIS }}</h4></center>
            </div>
          </div>
        </div>

        <div class="col-lg-2 col-md-3 col-6">
          <div class="card">
            <div class="card-body pb-50" style="position: relative;">
              <h4 class="fw-bolder mb-1">Dias Corridos:
                <i class="bi bi-calendar-event" style="font-size: 2rem; color: orange; float:right;"></i>
              </h4>
              <center><h4 class="fw-bolder mb-1">{{ BoletimDiarioVendaCAB1.CORRIDOS }}</h4></center>
            </div>
          </div>
        </div>

        <div class="col-lg-2 col-md-3 col-6">
          <div class="card">
            <div class="card-body pb-50" style="position: relative;">
              <h4 class="fw-bolder mb-1">% Ideal:
                <i class="bi bi-clipboard2-heart" style="font-size: 2rem; color: red; float:right;"></i>
              </h4>
              <h4 class="fw-bolder mb-1">{{ this.TextFormat(BoletimDiarioVendaCAB1.IDEAL, 'percent') }}</h4>
            </div>
          </div>
        </div>

        <div class="col-lg-2 col-md-3 col-6">
          <div class="card">
            <div class="card-body pb-50" style="position: relative;">
              <h4 class="fw-bolder mb-1">% Real:
                <i class="bi bi-clipboard2-check" style="font-size: 2rem; color: green; float:right;"></i>
              </h4>
              <h4 class="fw-bolder mb-1">{{ this.TextFormat(BoletimDiarioVendaCAB1.R, 'percent') }}</h4>
            </div>
          </div>
        </div>

        <div class="col-lg-2 col-md-3 col-6">
          <div class="card">
            <div class="card-body pb-50" style="position: relative;">
              <h4 class="fw-bolder mb-1">Há 1 Mês:
                <i class="bi bi-clock-history" style="font-size: 2rem; color: orange; float:right;"></i>
              </h4>
              <h4 class="fw-bolder mb-1">{{ this.TextFormat(BoletimDiarioVendaCAB1.R1, 'percent') }}</h4>
            </div>
          </div>
        </div>

        <div class="col-lg-2 col-md-3 col-6">
          <div class="card">
            <div class="card-body pb-50" style="position: relative;">
              <h4 class="fw-bolder mb-1">Há 2 Meses:
                <i class="bi bi-clock" style="font-size: 2rem; color: orange; float:right;"></i>
              </h4>
              <h4 class="fw-bolder mb-1">{{ this.TextFormat(BoletimDiarioVendaCAB1.R2, 'percent') }}</h4>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-12 col-24">
      <div class="row match-height">
        <div class="col-lg-2 col-md-3 col-6">
          <div class="card">
            <div class="card-body pb-50" style="position: relative;">
              <h4 class="fw-bolder mb-1">BP Valor:
                <i class="bi bi-cash-coin" style="font-size: 2rem; color: green; float:right;"></i>
              </h4>
              <h4 class="fw-bolder mb-1"> {{ "R$ " + this.TextFormat(BoletimDiarioVendaCAB2.METVAL, 'money') }}</h4>
            </div>
          </div>
        </div>

        <div class="col-lg-2 col-md-3 col-6">
          <div class="card">
            <div class="card-body pb-50" style="position: relative;">
              <h4 class="fw-bolder mb-1">BP Volume:
                <i class="bi bi-box-seam" style="font-size: 2rem; color: orange; float:right;"></i>
              </h4>
              <h4 class="fw-bolder mb-1">{{ this.TextFormat(BoletimDiarioVendaCAB2.METVOL, 'money') + " Kg" }} </h4>
            </div>
          </div>
        </div>

        <div class="col-lg-2 col-md-3 col-2">
          <div class="card">
            <div class="card-body pb-50" style="position: relative;">
              <h4 class="fw-bolder mb-1">% Valor:
                <i class="bi bi-cash-coin" style="font-size: 2rem; color: green; float:right;"></i>
              </h4>
              <h4 class="fw-bolder mb-1">{{ this.TextFormat(BoletimDiarioVendaCAB2.PERCVAL, 'percent') }}</h4>
            </div>
          </div>
        </div>

        <div class="col-lg-2 col-md-3 col-2">
          <div class="card">
            <div class="card-body pb-50" style="position: relative;">
              <h4 class="fw-bolder mb-1">% Volume:
                <i class="bi bi-box-seam" style="font-size: 2rem; color: orange; float:right;"></i>
              </h4>
              <h4 class="fw-bolder mb-1">{{ this.TextFormat(BoletimDiarioVendaCAB2.PERCVOL, 'percent') }}</h4>
            </div>
          </div>
        </div>

        <div class="col-lg-2 col-md-3 col-6">
          <div class="card">
            <div class="card-body pb-50" style="position: relative;">
              <h4 class="fw-bolder mb-1">KG Líquido:
                <i class="bi bi-box-seam" style="font-size: 2rem; color: orange; float:right;"></i>
              </h4>
              <h4 class="fw-bolder mb-1">{{ this.TextFormat(BoletimDiarioVendaCAB2.LIQUIDOKG, 'money') + " Kg" }}</h4>
            </div>
          </div>
        </div>

        <div class="col-lg-2 col-md-3 col-4">
          <div class="card">
            <div class="card-body pb-50" style="position: relative;">
              <h4 class="fw-bolder mb-1">R$ Líquido:
                <i class="bi bi-cash-coin" style="font-size: 2rem; color: green; float:right;"></i>
              </h4>
              <h4 class="fw-bolder mb-1">{{ "R$ " + this.TextFormat(BoletimDiarioVendaCAB2.LIQUIDO, 'money') }}</h4>
            </div>
          </div>
        </div>

        <div class="col-lg-3 col-md-3 col-6">
          <div class="card">
            <div class="card-body pb-50" style="position: relative;">
              <h4 class="fw-bolder mb-1">KG Entrada:
                <i class="bi bi-box-seam" style="font-size: 2rem; color: orange; float:right;"></i>
              </h4>
              <h4 class="fw-bolder mb-1">{{ this.TextFormat(BoletimDiarioVendaCAB2.ENTRADAPESO, 'money') + " Kg" }}</h4>
            </div>
          </div>
        </div>

        <div class="col-lg-3 col-md-3 col-6">
          <div class="card">
            <div class="card-body pb-50" style="position: relative;">
              <h4 class="fw-bolder mb-1">KG Devoluções:
                <i class="bi bi-box-seam" style="font-size: 2rem; color: red; float:right;"></i>
              </h4>
              <h4 class="fw-bolder mb-1">{{ this.TextFormat(BoletimDiarioVendaCAB2.DEVOLKG, 'money') + " Kg" }}</h4>
            </div>
          </div>
        </div>

        <div class="col-lg-3 col-md-3 col-3">
          <div class="card">
            <div class="card-body pb-50" style="position: relative;">
              <h4 class="fw-bolder mb-1">KG Corte:
                <i class="bi bi-scissors" style="font-size: 2rem; color: orange; float:right;"></i>
              </h4>
              <h4 class="fw-bolder mb-1">{{ this.TextFormat(BoletimDiarioVendaCAB2.QTDCORTE, 'money') + " Kg" }}</h4>
            </div>
          </div>
        </div>

        <div class="col-lg-3 col-md-3 col-6">
          <div class="card">
            <div class="card-body pb-50" style="position: relative;">
              <h4 class="fw-bolder mb-1">KG a Faturar:
                <i class="bi bi-box-seam" style="font-size: 2rem; color: orange; float:right;"></i>
              </h4>
              <h4 class="fw-bolder mb-1">{{ this.TextFormat(BoletimDiarioVendaCAB2.AFATURARKG, 'money') + " Kg" }}</h4>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-12 col-24">
      <div class="row match-height">
        <div class="col-lg-3 col-md-3 col-6">
          <div class="card">
            <div class="card-body pb-50" style="position: relative;">
              <h4 class="fw-bolder mb-1">R$ Entrada:
                <i class="bi bi-cash-coin" style="font-size: 4rem; color: green; float:right;"></i>
              </h4>
              <h4 class="fw-bolder mb-1">{{ "R$ " + this.TextFormat(BoletimDiarioVendaCAB2.ENTRADATOTAL, 'money') }}</h4>
            </div>
          </div>
        </div>

        <div class="col-lg-3 col-md-3 col-6">
          <div class="card">
            <div class="card-body pb-50" style="position: relative;">
              <h4 class="fw-bolder mb-1">R$ Devoluções:
                <i class="bi bi-cash-coin" style="font-size: 2rem; color: red; float:right;"></i>
              </h4>
              <h4 class="fw-bolder mb-1">{{ "R$ " + this.TextFormat(BoletimDiarioVendaCAB2.DEVOL, 'money') }}</h4>
            </div>
          </div>
        </div>

        <div class="col-lg-3 col-md-3 col-6">
          <div class="card">
            <div class="card-body pb-50" style="position: relative;">
              <h4 class="fw-bolder mb-1">R$ Corte:
                <i class="bi bi-scissors" style="font-size: 2rem; color: red; float:right;"></i>
              </h4>
              <h4 class="fw-bolder mb-1">{{ "R$ " + this.TextFormat(BoletimDiarioVendaCAB2.VLRCORTE, 'money') }}</h4>
            </div>
          </div>
        </div>

        <div class="col-lg-3 col-md-3 col-4">
          <div class="card">
            <div class="card-body pb-50" style="position: relative;">
              <h4 class="fw-bolder mb-1">R$ a Faturar:
                <i class="bi bi-cash-coin" style="font-size: 2rem; color: green; float:right;"></i>
              </h4>
              <h4 class="fw-bolder mb-1">{{ "R$ " + this.TextFormat(BoletimDiarioVendaCAB2.AFATURAR, 'money') }}</h4>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-12 col-24">
      <div class="row match-height">
        <div class="col-lg-3 col-md-3 col-3">
          <div class="card">
            <div class="card-body pb-50" style="position: relative;">
              <h4 class="fw-bolder mb-1">R$ Líquido:
                <i class="bi bi-cash-coin" style="font-size: 4rem; color: green; float:right;"></i>
              </h4>
              <h4 class="fw-bolder mb-1">{{ "R$ " + this.TextFormat(BoletimDiarioVendaCAB2.LIQUIDO, 'money') }}</h4>
            </div>
          </div>
        </div>

        <div class="col-lg-1 col-md-3 col-1">
          <div class="card">
            <div class="card-body pb-50" style="position: relative;">
              <br>
              <center> + </center>
            </div>
          </div>
        </div>

        <div class="col-lg-3 col-md-3 col-2">
          <div class="card">
            <div class="card-body pb-50" style="position: relative;">
              <h4 class="fw-bolder mb-1">R$ a Faturar:
                <i class="bi bi-cash-coin" style="font-size: 4rem; color: green; float:right;"></i>
              </h4>
              <h4 class="fw-bolder mb-1">{{ "R$ " + this.TextFormat(BoletimDiarioVendaCAB2.AFATURAR, 'money') }}</h4>
            </div>
          </div>
        </div>

        <div class="col-lg-1 col-md-3 col-1">
          <div class="card">
            <div class="card-body pb-50" style="position: relative;">
              <br>
              <center> = </center>
            </div>
          </div>
        </div>

        <div class="col-lg-3 col-md-3 col-3">
          <div class="card">
            <div class="card-body pb-50" style="position: relative;">
              <h4 class="fw-bolder mb-1">R$ Final:
                <i class="bi bi-cash-coin" style="font-size: 4rem; color: green; float:right;"></i>
              </h4>
              <h4 class="fw-bolder mb-1">{{ "R$ " + this.TextFormat(BoletimDiarioVendaCAB2.TOTALGERAL, 'money') }}</h4>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12" v-if="TabRelBoletimDiarioVendaPosition >= 0">
      <div class="card mb-4">
        <div class="card-body pb-60">

          <b-row class="mb-2 align-items-center">
            <b-col md="4">
              <b-form-group label="Agrupar Dados Por:" class="mb-0 font-weight-bold text-primary">
                <b-form-select v-model="agruparPorSelected" :options="agruparPorOptions" size="sm" @change="salvarConfiguracoesCache" />
              </b-form-group>
            </b-col>
            <b-col md="8" class="text-right">
              <b-button v-b-toggle="'collapse-colunas'" variant="outline-secondary" size="sm" class="mr-1">
                <i class="bi bi-eye-slash"></i> Ocultar/Exibir Colunas
              </b-button>
              <b-button variant="danger" type="submit" @click="TabRelBoletimDiarioVendaRowBack(-1)" v-if="TabRelBoletimDiarioVendaPosition > 0" size="sm">
                <span>VOLTAR</span>
              </b-button>
            </b-col>
          </b-row>

          <b-collapse id="collapse-colunas" class="mt-2 mb-3">
            <div class="p-2 border rounded bg-light">
              <span class="font-weight-bold d-block mb-2 font-size12 text-secondary">Desmarque os campos para removê-los da tabela:</span>
              
              <div class="mb-2 border-bottom pb-1">
                <span class="font-size11 text-muted font-weight-bold d-block mb-1">Estrutura de Hierarquia Comercial:</span>
                <b-form-checkbox-group v-model="colunasVisiveis" name="colunas-comerciais" @change="salvarConfiguracoesCache" class="d-flex flex-wrap">
                  <b-form-checkbox value="CODREG" class="font-size11 mr-3 mb-2">Cód. Região</b-form-checkbox>
                  <b-form-checkbox value="NOMEREG" class="font-size11 mr-3 mb-2">Região</b-form-checkbox>
                  <b-form-checkbox value="CODGER" class="font-size11 mr-3 mb-2">Cód. Gerente</b-form-checkbox>
                  <b-form-checkbox value="GERENTE" class="font-size11 mr-3 mb-2">Gerente</b-form-checkbox>
                  <b-form-checkbox value="CODGERREG" class="font-size11 mr-3 mb-2">Cód. Gerente Reg.</b-form-checkbox>
                  <b-form-checkbox value="GERENTEREG" class="font-size11 mr-3 mb-2">Gerente Regional</b-form-checkbox>
                  <b-form-checkbox value="CODCOORD" class="font-size11 mr-3 mb-2">Cód. Coordenador</b-form-checkbox>
                  <b-form-checkbox value="COORDENADOR" class="font-size11 mr-3 mb-2">Coordenador</b-form-checkbox>
                  <b-form-checkbox value="CODVEND" class="font-size11 mr-3 mb-2">Cód. Vendedor</b-form-checkbox>
                  <b-form-checkbox value="APELIDO" class="font-size11 mr-3 mb-2">Vendedor</b-form-checkbox>
                </b-form-checkbox-group>
              </div>

              <div>
                <span class="font-size11 text-muted font-weight-bold d-block mb-1">Métricas de Volume, Valores e Performance:</span>
                <b-form-checkbox-group v-model="colunasVisiveis" name="colunas-valores" @change="salvarConfiguracoesCache" class="d-flex flex-wrap">
                  <b-form-checkbox value="METVOL" class="font-size11 mr-3 mb-2">BP Volume</b-form-checkbox>
                  <b-form-checkbox value="METVAL" class="font-size11 mr-3 mb-2">BP Valor</b-form-checkbox>
                  <b-form-checkbox value="ENTRADATOTAL" class="font-size11 mr-3 mb-2">R$ Entrada</b-form-checkbox>
                  <b-form-checkbox value="ENTRADAPESO" class="font-size11 mr-3 mb-2">KG Entrada</b-form-checkbox>
                  <b-form-checkbox value="DEVOL" class="font-size11 mr-3 mb-2">R$ Devoluções</b-form-checkbox>
                  <b-form-checkbox value="DEVOLKG" class="font-size11 mr-3 mb-2">KG Devolução</b-form-checkbox>
                  <b-form-checkbox value="LIQUIDO" class="font-size11 mr-3 mb-2">R$ Líquido</b-form-checkbox>
                  <b-form-checkbox value="LIQUIDOKG" class="font-size11 mr-3 mb-2">KG Líquido</b-form-checkbox>
                  <b-form-checkbox value="PERCVAL" class="font-size11 mr-3 mb-2">% Valor</b-form-checkbox>
                  <b-form-checkbox value="PERCVOL" class="font-size11 mr-3 mb-2">% Volume</b-form-checkbox>
                  <b-form-checkbox value="AFATURAR" class="font-size11 mr-3 mb-2">R$ a Faturar</b-form-checkbox>
                  <b-form-checkbox value="AFATURARKG" class="font-size11 mr-3 mb-2">KG a Faturar</b-form-checkbox>
                  <b-form-checkbox value="VLRCORTE" class="font-size11 mr-3 mb-2">R$ Corte</b-form-checkbox>
                  <b-form-checkbox value="QTDCORTE" class="font-size11 mr-3 mb-2">KG Corte</b-form-checkbox>
                </b-form-checkbox-group>
              </div>

            </div>
          </b-collapse>

          <div v-if="TabRelBoletimDiarioVendaPosition == 0">
            <h4 class="fw-bolder mb-1">Detalhe</h4>

            <div id="TabRelBoletimDiarioVendaNV1">
              <b-table striped hover responsive small sticky-header :items="TabRelBoletimDiarioVendaNV1View" :fields="CamposTabelaDinamica" selectable select-mode="single" table-class="font-size11" thead-class="font-size11" thead-tr-class="font-size11">

                <template #head(CODREG)="data">
                  <div class="header-com-input">
                    <span class="btn-mover" @click.stop="moverColuna(data.field.key, -1)">‹</span>
                    <span>Cód.Região</span>
                    <span v-if="!editingCodReg" @click.stop="editingCodReg = true" class="filter-block"></span>
                    <input v-else type="number" class="input-filtro" placeholder="Cód." v-model="filtroCodReg" @blur="editingCodReg = false" />
                    <span class="btn-mover" @click.stop="moverColuna(data.field.key, 1)">›</span>
                  </div>
                </template>

                <template #head(NOMEREG)="data">
                  <div class="header-com-input">
                    <span class="btn-mover" @click.stop="moverColuna(data.field.key, -1)">‹</span>
                    <span>Região</span>
                    <span v-if="!editingRegiao" @click.stop="editingRegiao = true" class="filter-block"></span>
                    <input v-else type="text" class="input-filtro" placeholder="Digite..." v-model="filtroRegiao" @blur="editingRegiao = false" />
                    <span class="btn-mover" @click.stop="moverColuna(data.field.key, 1)">›</span>
                  </div>
                </template>

                <template #head(CODGER)="data">
                  <div class="header-com-input">
                    <span class="btn-mover" @click.stop="moverColuna(data.field.key, -1)">‹</span>
                    <span>Cód.Gerente</span>
                    <span v-if="!editingCodGer" @click.stop="editingCodGer = true" class="filter-block"></span>
                    <input v-else type="number" class="input-filtro" placeholder="Cód." v-model="filtroCodGer" @blur="editingCodGer = false" />
                    <span class="btn-mover" @click.stop="moverColuna(data.field.key, 1)">›</span>
                  </div>
                </template>

                <template #head(GERENTE)="data">
                  <div class="header-com-input">
                    <span class="btn-mover" @click.stop="moverColuna(data.field.key, -1)">‹</span>
                    <span>Gerente</span>
                    <span v-if="!editingGerente" @click.stop="editingGerente = true" class="filter-block"></span>
                    <input v-else type="text" class="input-filtro" placeholder="Nome" v-model="filtroGerente" @blur="editingGerente = false" />
                    <span class="btn-mover" @click.stop="moverColuna(data.field.key, 1)">›</span>
                  </div>
                </template>

                <template #head(CODGERREG)="data">
                  <div class="header-com-input">
                    <span class="btn-mover" @click.stop="moverColuna(data.field.key, -1)">‹</span>
                    <span>Cód.Gerente Reg.</span>
                    <span v-if="!editingCodGerReg" @click.stop="editingCodGerReg = true" class="filter-block"></span>
                    <input v-else type="number" class="input-filtro" placeholder="Cód." v-model="filtroCodGerReg" @blur="editingCodGerReg = false" />
                    <span class="btn-mover" @click.stop="moverColuna(data.field.key, 1)">›</span>
                  </div>
                </template>

                <template #head(GERENTEREG)="data">
                  <div class="header-com-input">
                    <span class="btn-mover" @click.stop="moverColuna(data.field.key, -1)">‹</span>
                    <span>Gerente Regional</span>
                    <span class="btn-mover" @click.stop="moverColuna(data.field.key, 1)">›</span>
                  </div>
                </template>

                <template #head(CODCOORD)="data">
                  <div class="header-com-input">
                    <span class="btn-mover" @click.stop="moverColuna(data.field.key, -1)">‹</span>
                    <span>Cod.Coordenador</span>
                    <span v-if="!editingCodCoord" @click.stop="editingCodCoord = true" class="filter-block"></span>
                    <input v-else type="number" class="input-filtro" placeholder="Cód." v-model="filtroCodCoord" @blur="editingCodCoord = false" />
                    <span class="btn-mover" @click.stop="moverColuna(data.field.key, 1)">›</span>
                  </div>
                </template>

                <template #head(COORDENADOR)="data">
                  <div class="header-com-input">
                    <span class="btn-mover" @click.stop="moverColuna(data.field.key, -1)">‹</span>
                    <span>Coordenador</span>
                    <span v-if="!editingCoordenador" @click.stop="editingCoordenador = true" class="filter-block"></span>
                    <input v-else type="text" class="input-filtro" placeholder="Nome" v-model="filtroCoordenador" @blur="editingCoordenador = false" />
                    <span class="btn-mover" @click.stop="moverColuna(data.field.key, 1)">›</span>
                  </div>
                </template>

                <template #head(CODVEND)="data">
                  <div class="header-com-input">
                    <span class="btn-mover" @click.stop="moverColuna(data.field.key, -1)">‹</span>
                    <span>Cód.Vendedor</span>
                    <span v-if="!editingCodVend" @click.stop="editingCodVend = true" class="filter-block"></span>
                    <input v-else type="number" class="input-filtro" placeholder="Cód." v-model="filtroCodVend" @blur="editingCodVend = false" />
                    <span class="btn-mover" @click.stop="moverColuna(data.field.key, 1)">›</span>
                  </div>
                </template>

                <template #head(APELIDO)="data">
                  <div class="header-com-input">
                    <span class="btn-mover" @click.stop="moverColuna(data.field.key, -1)">‹</span>
                    <span>Vendedor</span>
                    <span v-if="!editingVendedor" @click.stop="editingVendedor = true" class="filter-block"></span>
                    <input v-else type="text" class="input-filtro" placeholder="Nome" v-model="filtroVendedor" @blur="editingVendedor = false" />
                    <span class="btn-mover" @click.stop="moverColuna(data.field.key, 1)">›</span>
                  </div>
                </template>

                <template #head()="data">
                  <div class="header-com-input justify-content-between">
                    <span class="btn-mover" @click.stop="moverColuna(data.field.key, -1)">‹</span>
                    <span>{{ data.label }}</span>
                    <span class="btn-mover" @click.stop="moverColuna(data.field.key, 1)">›</span>
                  </div>
                </template>

                <template #cell(METVOL)="row">{{ TextFormat(row.value, 'money') }}</template>
                <template #cell(METVAL)="row">{{ 'R$ ' + TextFormat(row.value, 'money') }}</template>
                <template #cell(ENTRADATOTAL)="row">{{ 'R$ ' + TextFormat(row.value, 'money') }}</template>
                <template #cell(ENTRADAPESO)="row">{{ TextFormat(row.value, 'money') }}</template>
                <template #cell(DEVOL)="row">{{ 'R$ ' + TextFormat(row.value, 'money') }}</template>
                <template #cell(DEVOLKG)="row">{{ TextFormat(row.value, 'money') }}</template>
                <template #cell(LIQUIDO)="row">{{ 'R$ ' + TextFormat(row.value, 'money') }}</template>
                <template #cell(LIQUIDOKG)="row">{{ TextFormat(row.value, 'money') }}</template>
                <template #cell(PERCVAL)="row">{{ TextFormat(row.value, 'percent') }}</template>
                <template #cell(PERCVOL)="row">{{ TextFormat(row.value, 'percent') }}</template>
                <template #cell(AFATURAR)="row">{{ 'R$ ' + TextFormat(row.value, 'money') }}</template>
                <template #cell(AFATURARKG)="row">{{ TextFormat(row.value, 'money') }}</template>
                <template #cell(VLRCORTE)="row">{{ 'R$ ' + TextFormat(row.value, 'money') }}</template>
                <template #cell(QTDCORTE)="row">{{ TextFormat(row.value, 'money') }}</template>

                <template v-slot:custom-foot>
                  <tr>
                    <td class="bg-secondary text-white font-weight-bold" :colspan="QuantidadeColunasHierarquia">Total Geral</td>
                    <td v-if="colunasVisiveis.includes('METVOL')" class="bg-secondary text-white">{{ 'R$ ' + TextFormat(BoletimDiarioVendaCAB2.METVOL, 'money') }}</td>
                    <td v-if="colunasVisiveis.includes('METVAL')" class="bg-secondary text-white">{{ TextFormat(BoletimDiarioVendaCAB2.METVAL, 'money') }}</td>
                    <td v-if="colunasVisiveis.includes('ENTRADATOTAL')" class="bg-secondary text-white">{{ 'R$ ' + TextFormat(BoletimDiarioVendaCAB2.ENTRADATOTAL, 'money') }}</td>
                    <td v-if="colunasVisiveis.includes('ENTRADAPESO')" class="bg-secondary text-white">{{ TextFormat(BoletimDiarioVendaCAB2.ENTRADAPESO, 'money') }}</td>
                    <td v-if="colunasVisiveis.includes('DEVOL')" class="bg-secondary text-white">{{ 'R$ ' + TextFormat(BoletimDiarioVendaCAB2.DEVOL, 'money') }}</td>
                    <td v-if="colunasVisiveis.includes('DEVOLKG')" class="bg-secondary text-white">{{ TextFormat(BoletimDiarioVendaCAB2.DEVOLKG, 'money') }}</td>
                    <td v-if="colunasVisiveis.includes('LIQUIDO')" class="bg-secondary text-white">{{ 'R$ ' + TextFormat(BoletimDiarioVendaCAB2.LIQUIDO, 'money') }}</td>
                    <td v-if="colunasVisiveis.includes('LIQUIDOKG')" class="bg-secondary text-white">{{ TextFormat(BoletimDiarioVendaCAB2.LIQUIDOKG, 'money') }}</td>
                    <td v-if="colunasVisiveis.includes('PERCVAL')" class="bg-secondary text-white">{{ TextFormat(BoletimDiarioVendaCAB2.PERCVAL, 'percent') }}</td>
                    <td v-if="colunasVisiveis.includes('PERCVOL')" class="bg-secondary text-white">{{ TextFormat(BoletimDiarioVendaCAB2.PERCVOL, 'percent') }}</td>
                    <td v-if="colunasVisiveis.includes('AFATURAR')" class="bg-secondary text-white">{{ TextFormat(BoletimDiarioVendaCAB2.AFATURAR, 'money') }}</td>
                    <td v-if="colunasVisiveis.includes('AFATURARKG')" class="bg-secondary text-white">{{ TextFormat(BoletimDiarioVendaCAB2.AFATURARKG, 'money') }}</td>
                    <td v-if="colunasVisiveis.includes('VLRCORTE')" class="bg-secondary text-white">{{ 'R$ ' + TextFormat(BoletimDiarioVendaCAB2.VLRCORTE, 'money') }}</td>
                    <td v-if="colunasVisiveis.includes('QTDCORTE')" class="bg-secondary text-white">{{ TextFormat(BoletimDiarioVendaCAB2.QTDCORTE, 'money') }}</td>
                  </tr>
                </template>

              </b-table>
            </div>

            <div class="col-2" style="float:right">
              <b-form-group label="">
                <b-form-select v-model="exportarParaSelected" :options="exportarParaOptions" @change="ExportarDoc('TabRelBoletimDiarioVendaNV1', 'RelatorioBolerimDiarioVendas')"></b-form-select>
              </b-form-group>
            </div>

          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import VueApexCharts from 'vue-apexcharts'
import 'bootstrap-icons/font/bootstrap-icons.css'
import apiPortalSky from '@/services/apiPortalSky'
import AlertaMsg from '@/customPortal/AlertaMsg.vue'
import Spinner from '@/components/Spinner.vue'
import UtilVUE from '@/customPortal/UtilVUE.vue'

import {
  BFormGroup, BRow, BCol, BButton, BTable, BFormSelect, BFormInput, BCollapse, BCard, VBToggle, BFormDatepicker, BFormCheckboxGroup, BFormCheckbox
} from 'bootstrap-vue'

export default {
  components: {
    VueApexCharts, Multiselect, BFormGroup, BRow, BCol, BButton, BTable, BFormSelect, BFormInput, BCollapse, BCard, BFormDatepicker, BFormCheckboxGroup, BFormCheckbox
  },
  directives: { 'b-toggle': VBToggle },
  data() {
    return {
      colunasVisiveis: ['CODREG', 'NOMEREG', 'CODGER', 'GERENTE', 'CODGERREG', 'GERENTEREG', 'CODCOORD', 'COORDENADOR', 'CODVEND', 'APELIDO', 'METVOL', 'METVAL', 'ENTRADATOTAL', 'ENTRADAPESO', 'DEVOL', 'DEVOLKG', 'LIQUIDO', 'LIQUIDOKG', 'PERCVAL', 'PERCVOL', 'AFATURAR', 'AFATURARKG', 'VLRCORTE', 'QTDCORTE'],
      agruparPorSelected: 'NENHUM',
      agruparPorOptions: [
        { value: 'NENHUM', text: 'Sem Agrupamento (Aberto por Vendedor)' },
        { value: 'NOMEREG', text: 'Agrupar por Região' },
        { value: 'GERENTE', text: 'Agrupar por Gerente' },
        { value: 'COORDENADOR', text: 'Agrupar por Coordenador' }
      ],

      filtroRegiao: '', filtroCodGer: '', filtroGerente: '', filtroCodCoord: '', filtroCodVend: '', filtroVendedor: '', filtroCodReg: '', filtroCodGerReg: '', filtroCoordenador: '',
      editingRegiao: false, editingCodGer: false, editingGerente: false, editingCodCoord: false, editingCodVend: false, editingVendedor: false, editingCodReg: false, editingCodGerReg: false, editingCoordenador: false,

      showFiltro: true,
      FiltroRelatorio: [],
      RelName: '',
      RelRota: '',
      BoletimDiarioVendaCAB1: { UTEIS: 0, CORRIDOS: 0, IDEAL: 0, R: 0, R1: 0, R2: 0 },
      BoletimDiarioVendaCAB2: { METVOL: 0, METVAL: 0, ENTRADATOTAL: 0, ENTRADAPESO: 0, DEVOL: 0, DEVOLKG: 0, LIQUIDO: 0, LIQUIDOKG: 0, PERCVAL: 0, PERCVOL: 0, AFATURAR: 0, AFATURARKG: 0, VLRCORTE: 0, QTDCORTE: 0, TOTALGERAL: 0 },

      TabRelBoletimDiarioVendaNV1: [],
      
      TabRelBoletimDiarioVendaNV1fields: [
        { key: 'CODREG', label: 'Cód.Região', sortable: true, tdClass: 'td200', isComercial: true },
        { key: 'NOMEREG', label: 'Região', sortable: true, tdClass: 'td200', isComercial: true },
        { key: 'CODGER', label: 'Cód.Gerente', sortable: false, tdClass: 'td200', isComercial: true },
        { key: 'GERENTE', label: 'Gerente', sortable: true, tdClass: 'td200', isComercial: true },
        { key: 'CODGERREG', label: 'Cód.Gerente Reg.', sortable: false, tdClass: 'td200', isComercial: true },
        { key: 'GERENTEREG', label: 'Gerente Regional', sortable: true, tdClass: 'td200', isComercial: true },
        { key: 'CODCOORD', label: 'Cod.Coordenador', sortable: true, tdClass: 'td200', isComercial: true },
        { key: 'COORDENADOR', label: 'Coordenador', sortable: true, tdClass: 'td200', isComercial: true },
        { key: 'CODVEND', label: 'Cód.Vendedor', sortable: false, tdClass: 'td200', isComercial: true },
        { key: 'APELIDO', label: 'Vendedor', sortable: true, tdClass: 'td200', isComercial: true },
        { key: 'METVOL', label: 'BP Volume', sortable: true, tdClass: 'td200' },
        { key: 'METVAL', label: 'BP Valor', sortable: true, tdClass: 'td200' },
        { key: 'ENTRADATOTAL', label: 'R$ Entrada', sortable: true, tdClass: 'td200' },
        { key: 'ENTRADAPESO', label: 'KG Entrada', sortable: true, tdClass: 'td200' },
        { key: 'DEVOL', label: 'R$ Devoluções', sortable: true, tdClass: 'td200' },
        { key: 'DEVOLKG', label: 'KG Devolução', sortable: true, tdClass: 'td200' },
        { key: 'LIQUIDO', label: 'R$ Líquido', sortable: true, tdClass: 'td200' },
        { key: 'LIQUIDOKG', label: 'KG Líquido', sortable: true, tdClass: 'td200' },
        { key: 'PERCVAL', label: '% Valor', sortable: true, tdClass: 'td200' },
        { key: 'PERCVOL', label: '% Volume', sortable: true, tdClass: 'td200' },
        { key: 'AFATURAR', label: 'R$ a Faturar', sortable: true, tdClass: 'td200' },
        { key: 'AFATURARKG', label: 'KG a Faturar', sortable: true, tdClass: 'td200' },
        { key: 'VLRCORTE', label: 'R$ Corte', sortable: true, tdClass: 'td200' },
        { key: 'QTDCORTE', label: 'KG Corte', sortable: true, tdClass: 'td200' },
      ],
      PeridoIni: '', PeridoFin: '', DataCorte: '',
      Motivo: { "name": "Comercial", "code": "Comercial" },
      MotivoOption: [
        { name: 'Comercial', code: 'Comercial' }, { name: 'Fiscal', code: 'Fiscal' }, { name: 'Logistica', code: 'Logistica' }, { name: 'Fabrica', code: 'Fabrica' }, { name: 'Marketing', code: 'Marketing' }, { name: 'Sistema', code: 'Sistema' }, { name: 'Todos', code: 'T' }
      ],
      CodVend: [], CodVendOption: [], CodCoord: [], CodCoordOption: [], CodGer: [], CodGerOption: [], CodReg: [], CodRegOption: [],
      Ativo: { "name": "Todos", "code": "T" },
      AtivoOption: [{ name: 'Ativo', code: 'S' }, { name: 'Inativo', code: 'N' }, { name: 'Todos', code: 'T' }],
      exportarParaSelected: 'Exporte',
      exportarParaOptions: [{ value: 'Exporte', text: 'Exporte' }, { value: 'XLSX', text: 'Excel' }],
      TabRelBoletimDiarioVendaPosition: -1,
    }
  },
  methods: {
    // Grava as preferências do usuário no LocalStorage do Navegador
    salvarConfiguracoesCache() {
      const objetoConfig = {
        agruparPorSelected: this.agruparPorSelected,
        colunasVisiveis: this.colunasVisiveis,
        ordemCamposKeys: this.TabRelBoletimDiarioVendaNV1fields.map(f => f.key)
      };
      localStorage.setItem('cache_boletim_vendas_config', JSON.stringify(objetoConfig));
    },

    // Carrega as preferências salvas no LocalStorage
    carregarConfiguracoesCache() {
      const cacheSalvo = localStorage.getItem('cache_boletim_vendas_config');
      if (cacheSalvo) {
        try {
          const dadosConfig = JSON.parse(cacheSalvo);
          if (dadosConfig.agruparPorSelected) {
            this.agruparPorSelected = dadosConfig.agruparPorSelected;
          }
          if (dadosConfig.colunasVisiveis) {
            this.colunasVisiveis = dadosConfig.colunasVisiveis;
          }
          if (dadosConfig.ordemCamposKeys && dadosConfig.ordemCamposKeys.length > 0) {
            // Reordena o array de campos baseado no mapa de chaves salvo anteriormente
            const camposReordenados = [];
            dadosConfig.ordemCamposKeys.forEach(key => {
              const campoEncontrado = this.TabRelBoletimDiarioVendaNV1fields.find(f => f.key === key);
              if (campoEncontrado) {
                camposReordenados.push(campoEncontrado);
              }
            });
            // Adiciona campos novos caso surjam na estrutura padrão
            this.TabRelBoletimDiarioVendaNV1fields.forEach(campoOriginal => {
              if (!camposReordenados.some(c => c.key === campoOriginal.key)) {
                camposReordenados.push(campoOriginal);
              }
            });
            this.TabRelBoletimDiarioVendaNV1fields = camposReordenados;
          }
        } catch (e) {
          console.error("Falha ao descriptografar configurações locais de cache da tabela:", e);
        }
      }
    },

    moverColuna(key, direcao) {
      const indexOrigem = this.TabRelBoletimDiarioVendaNV1fields.findIndex(f => f.key === key);
      const indexDestino = indexOrigem + direcao;
      if (indexDestino >= 0 && indexDestino < this.TabRelBoletimDiarioVendaNV1fields.length) {
        const elemento = this.TabRelBoletimDiarioVendaNV1fields.splice(indexOrigem, 1)[0];
        this.TabRelBoletimDiarioVendaNV1fields.splice(indexDestino, 0, elemento);
        this.salvarConfiguracoesCache();
      }
    },

    toggleFullLayout() {
      if (UtilVUE && typeof UtilVUE.toggleFullLayout === 'function') {
        UtilVUE.toggleFullLayout(this.$router, this.$route);
      }
    },

    TextFormat(valor, tipo) {
      if (valor === undefined || valor === null) {
        return tipo === 'percent' ? '0,00%' : '0,00';
      }
      return UtilVUE.TextFormat(valor, tipo);
    },

    async MostraReport() { 
      let notification = ""; 
      Spinner.StarLoad(); 
      const usuario = this.$session.get('usuario'); 
      let URLpost = `/Report/MostraReport?CODUSU=${usuario.codusu}&ROTA=${this.RelRota}`; 
      
      await apiPortalSky.post(URLpost, "")
        .then(res => { 
          if (res.status === 200 && res.data != null) { 
            this.RelName = res.data.descricaoRelatorio; 
          } 
        })
        .catch(err => { 
          notification = AlertaMsg.FormataMsgAPIError(err); 
          AlertaMsg.FormataMsg(notification); 
        }); 
        
      if (notification === '') {
        Spinner.EndLoad();
      }
    },

    async ConsultarOpcoes() { 
      let notification = ""; 
      Spinner.StarLoad(); 
      const usuario = this.$session.get('usuario'); 
      let URLpost = `/Opcoes/ConsultaOpcoes?CODUSU=${usuario.codusu}&OPCAO=Vendedor`; 
      
      await apiPortalSky.post(URLpost, "")
        .then(res => { 
          if (res.status === 200 && res.data.length > 0) { 
            this.CodVendOption = res.data; 
            this.CodCoordOption = res.data; 
            this.CodGerOption = res.data; 
          } 
        })
        .catch(err => { 
          notification = AlertaMsg.FormataMsgAPIError(err); 
        }); 
        
      if (notification === '') { 
        let URLreg = `/Opcoes/ConsultaOpcoes?CODUSU=${usuario.codusu}&OPCAO=Regiao`; 
        await apiPortalSky.post(URLreg, "")
          .then(res => { 
            if (res.status === 200 && res.data.length > 0) {
              this.CodRegOption = res.data; 
            }
          })
          .catch(err => { 
            notification = AlertaMsg.FormataMsgAPIError(err); 
          }); 
      } 
      if (notification === '') {
        Spinner.EndLoad();
      }
    },

    async ConsultarRelatorio() { 
      Spinner.StarLoad(); 
      this.showFiltro = false; 
      const usuario = this.$session.get('usuario'); 
      this.FiltroRelatorio = []; 
      this.TabRelBoletimDiarioVendaNV1 = []; 
      this.TabRelBoletimDiarioVendaPosition = 0; 
      this.TabRelBoletimDiarioVendaRowBack(0); 
      
      if (this.PeridoIni != "") { this.FiltroRelatorio.push({ parametro: 'PERIODO_INI', valor: this.PeridoIni }); }
      if (this.PeridoFin != "") { this.FiltroRelatorio.push({ parametro: 'PERIODO_FIN', valor: this.PeridoFin }); }
      if (this.DataCorte != "") { this.FiltroRelatorio.push({ parametro: 'DATACORTE', valor: this.DataCorte }); }
      if (this.CodVend && !Array.isArray(this.CodVend)) { this.FiltroRelatorio.push({ parametro: 'CODVEND', valor: this.CodVend.code }); }
      if (this.CodCoord && !Array.isArray(this.CodCoord)) { this.FiltroRelatorio.push({ parametro: 'CODCOORD', valor: this.CodCoord.code }); }
      if (this.CodGer && !Array.isArray(this.CodGer)) { this.FiltroRelatorio.push({ parametro: 'CODGER', valor: this.CodGer.code }); }
      if (this.Motivo && !Array.isArray(this.Motivo)) { this.FiltroRelatorio.push({ parametro: 'MOTIVO', valor: this.Motivo.code }); }
      this.CodReg.forEach(i => this.FiltroRelatorio.push({ parametro: 'CODREG', valor: i.code })); 
      if (this.Ativo && !Array.isArray(this.Ativo)) { this.FiltroRelatorio.push({ parametro: 'ATIVO', valor: this.Ativo.code }); }
      
      let ParametroJson = JSON.parse(JSON.stringify(this.FiltroRelatorio)); 
      
      await apiPortalSky.post(`/Report/ExecutaRelBoletimDiarioVenda?CODUSU=${usuario.codusu}&Nivel=CAB1`, ParametroJson)
        .then(res => { 
          if (res.status === 200 && res.data.length > 0) {
            this.BoletimDiarioVendaCAB1 = res.data[0]; 
          }
        }); 
        
      await apiPortalSky.post(`/Report/ExecutaRelBoletimDiarioVenda?CODUSU=${usuario.codusu}&Nivel=NIV1`, ParametroJson)
        .then(res => { 
          if (res.status === 200 && res.data.length > 0) { 
            this.TabRelBoletimDiarioVendaNV1 = res.data; 
            this.BoletimDiarioVendaCAB2.METVOL = this.TabRelBoletimDiarioVendaNV1Total("METVOL"); 
            this.BoletimDiarioVendaCAB2.METVAL = this.TabRelBoletimDiarioVendaNV1Total("METVAL"); 
            this.BoletimDiarioVendaCAB2.ENTRADATOTAL = this.TabRelBoletimDiarioVendaNV1Total("ENTRADATOTAL"); 
            this.BoletimDiarioVendaCAB2.ENTRADAPESO = this.TabRelBoletimDiarioVendaNV1Total("ENTRADAPESO"); 
            this.BoletimDiarioVendaCAB2.DEVOL = this.TabRelBoletimDiarioVendaNV1Total("DEVOL"); 
            this.BoletimDiarioVendaCAB2.DEVOLKG = this.TabRelBoletimDiarioVendaNV1Total("DEVOLKG"); 
            this.BoletimDiarioVendaCAB2.LIQUIDO = this.TabRelBoletimDiarioVendaNV1Total("LIQUIDO"); 
            this.BoletimDiarioVendaCAB2.LIQUIDOKG = this.TabRelBoletimDiarioVendaNV1Total("LIQUIDOKG"); 
            this.BoletimDiarioVendaCAB2.PERCVAL = this.TabRelBoletimDiarioVendaNV1Total("PERCVAL"); 
            this.BoletimDiarioVendaCAB2.PERCVOL = this.TabRelBoletimDiarioVendaNV1Total("PERCVOL"); 
            this.BoletimDiarioVendaCAB2.AFATURAR = this.TabRelBoletimDiarioVendaNV1Total("AFATURAR"); 
            this.BoletimDiarioVendaCAB2.AFATURARKG = this.TabRelBoletimDiarioVendaNV1Total("AFATURARKG"); 
            this.BoletimDiarioVendaCAB2.VLRCORTE = this.TabRelBoletimDiarioVendaNV1Total("VLRCORTE"); 
            this.BoletimDiarioVendaCAB2.QTDCORTE = this.TabRelBoletimDiarioVendaNV1Total("QTDCORTE"); 
            this.BoletimDiarioVendaCAB2.TOTALGERAL = (this.BoletimDiarioVendaCAB2.LIQUIDO || 0) + (this.BoletimDiarioVendaCAB2.AFATURAR || 0);
          } 
        }); 
      Spinner.EndLoad(); 
    },

    TabRelBoletimDiarioVendaNV1Total(C) { 
      let V = 0; 
      if (!this.TabRelBoletimDiarioVendaNV1 || this.TabRelBoletimDiarioVendaNV1.length === 0) {
        return 0;
      }
      switch (C) { 
        case 'METVOL': V = this.TabRelBoletimDiarioVendaNV1.reduce((a, b) => a + (b.METVOL || 0), 0.0); break; 
        case 'METVAL': V = this.TabRelBoletimDiarioVendaNV1.reduce((a, b) => a + (b.METVAL || 0), 0.0); break; 
        case 'ENTRADATOTAL': V = this.TabRelBoletimDiarioVendaNV1.reduce((a, b) => a + (b.ENTRADATOTAL || 0), 0.0); break; 
        case 'ENTRADAPESO': V = this.TabRelBoletimDiarioVendaNV1.reduce((a, b) => a + (b.ENTRADAPESO || 0), 0.0); break; 
        case 'DEVOL': V = this.TabRelBoletimDiarioVendaNV1.reduce((a, b) => a + (b.DEVOL || 0), 0.0); break; 
        case 'DEVOLKG': V = this.TabRelBoletimDiarioVendaNV1.reduce((a, b) => a + (b.DEVOLKG || 0), 0.0); break; 
        case 'LIQUIDO': V = this.TabRelBoletimDiarioVendaNV1.reduce((a, b) => a + (b.LIQUIDO || 0), 0.0); break; 
        case 'LIQUIDOKG': V = this.TabRelBoletimDiarioVendaNV1.reduce((a, b) => a + (b.LIQUIDOKG || 0), 0.0); break; 
        case 'PERCVAL': 
          const tMv = this.TabRelBoletimDiarioVendaNV1Total("METVAL");
          const tL = this.TabRelBoletimDiarioVendaNV1Total("LIQUIDO"); 
          if (tMv > 0) { V = (tL / tMv) * 100; } 
          break; 
        case 'PERCVOL': 
          const tMvol = this.TabRelBoletimDiarioVendaNV1Total("METVOL");
          const tLkg = this.TabRelBoletimDiarioVendaNV1Total("LIQUIDOKG"); 
          if (tMvol > 0) { V = (tLkg / tMvol) * 100; } 
          break; 
        case 'AFATURAR': V = this.TabRelBoletimDiarioVendaNV1.reduce((a, b) => a + (b.AFATURAR || 0), 0.0); break; 
        case 'AFATURARKG': V = this.TabRelBoletimDiarioVendaNV1.reduce((a, b) => a + (b.AFATURARKG || 0), 0.0); break; 
        case 'QTDCORTE': V = this.TabRelBoletimDiarioVendaNV1.reduce((a, b) => a + (b.QTDCORTE || 0), 0.0); break; 
        case 'VLRCORTE': V = this.TabRelBoletimDiarioVendaNV1.reduce((a, b) => a + (b.VLRCORTE || 0), 0.0); break; 
      } 
      return !isNaN(V) ? V : 0; 
    },

    TabRelBoletimDiarioVendaRowBack(R) { 
      if (R == -1) { 
        this.TabRelBoletimDiarioVendaPosition--; 
      } else { 
        this.TabRelBoletimDiarioVendaPosition = R; 
      } 
    },

    ExportarDoc(E, D) { 
      let Data = this.TabRelBoletimDiarioVendaNV1; 
      UtilVUE.ExportDoc(this.exportarParaSelected, D, E, Data); 
      this.exportarParaSelected = 'Exporte'; 
    }
  },
  computed: {
    TabRelBoletimDiarioVendaNV1View() {
      let items = this.TabRelBoletimDiarioVendaNV1;

      if (this.filtroRegiao) { items = items.filter(i => i.NOMEREG && i.NOMEREG.toLowerCase().includes(this.filtroRegiao.toLowerCase())); }
      if (this.filtroCodGer) { items = items.filter(i => i.CODGER && i.CODGER.toString().includes(this.filtroCodGer)); }
      if (this.filtroGerente) { items = items.filter(i => i.GERENTE && i.GERENTE.toLowerCase().includes(this.filtroGerente.toLowerCase())); }
      if (this.filtroCodCoord) { items = items.filter(i => i.CODCOORD && i.CODCOORD.toString().includes(this.filtroCodCoord)); }
      if (this.filtroCodVend) { items = items.filter(i => i.CODVEND && i.CODVEND.toString().includes(this.filtroCodVend)); }
      if (this.filtroVendedor) { items = items.filter(i => i.APELIDO && i.APELIDO.toLowerCase().includes(this.filtroVendedor.toLowerCase())); }
      if (this.filtroCodReg) { items = items.filter(i => i.CODREG && i.CODREG.toString().includes(this.filtroCodReg)); }
      if (this.filtroCoordenador) { items = items.filter(i => i.COORDENADOR && i.COORDENADOR.toLowerCase().includes(this.filtroCoordenador.toLowerCase())); }

      if (this.agruparPorSelected === 'NENHUM') {
        return items;
      }

      const campoGrupo = this.agruparPorSelected;
      const gruposMap = items.reduce((acc, current) => {
        const chaveGrupo = current[campoGrupo] || 'Não Identificado';
        
        if (!acc[chaveGrupo]) {
          acc[chaveGrupo] = {
            CODREG: current.CODREG, NOMEREG: current.NOMEREG, CODGER: current.CODGER, GERENTE: current.GERENTE, CODCOORD: current.CODCOORD, COORDENADOR: current.COORDENADOR, CODVEND: '-', APELIDO: 'ACUMULADO DO GRUPO',
            METVOL: 0, METVAL: 0, ENTRADATOTAL: 0, ENTRADAPESO: 0, DEVOL: 0, DEVOLKG: 0, LIQUIDO: 0, LIQUIDOKG: 0, AFATURAR: 0, AFATURARKG: 0, VLRCORTE: 0, QTDCORTE: 0
          };
        }

        acc[chaveGrupo].METVOL += current.METVOL || 0;
        acc[chaveGrupo].METVAL += current.METVAL || 0;
        acc[chaveGrupo].ENTRADATOTAL += current.ENTRADATOTAL || 0;
        acc[chaveGrupo].ENTRADAPESO += current.ENTRADAPESO || 0;
        acc[chaveGrupo].DEVOL += current.DEVOL || 0;
        acc[chaveGrupo].DEVOLKG += current.DEVOLKG || 0;
        acc[chaveGrupo].LIQUIDO += current.LIQUIDO || 0;
        acc[chaveGrupo].LIQUIDOKG += current.LIQUIDOKG || 0;
        acc[chaveGrupo].AFATURAR += current.AFATURAR || 0;
        acc[chaveGrupo].AFATURARKG += current.AFATURARKG || 0;
        acc[chaveGrupo].VLRCORTE += current.VLRCORTE || 0;
        acc[chaveGrupo].QTDCORTE += current.QTDCORTE || 0;

        return acc;
      }, {});

      return Object.values(gruposMap).map(grupo => {
        grupo.PERCVAL = grupo.METVAL > 0 ? (grupo.LIQUIDO / grupo.METVAL) * 100 : 0;
        grupo.PERCVOL = grupo.METVOL > 0 ? (grupo.LIQUIDOKG / grupo.METVOL) * 100 : 0;
        return grupo;
      });
    },

    CamposTabelaDinamica() {
      let colunas = [...this.TabRelBoletimDiarioVendaNV1fields];
      
      if (this.agruparPorSelected === 'NOMEREG') {
        colunas = colunas.filter(c => !['CODGER', 'GERENTE', 'CODGERREG', 'GERENTEREG', 'CODCOORD', 'COORDENADOR', 'CODVEND', 'APELIDO'].includes(c.key));
      } else if (this.agruparPorSelected === 'GERENTE') {
        colunas = colunas.filter(c => !['CODCOORD', 'COORDENADOR', 'CODVEND', 'APELIDO'].includes(c.key));
      } else if (this.agruparPorSelected === 'COORDENADOR') {
        colunas = colunas.filter(c => !['CODVEND', 'APELIDO'].includes(c.key));
      }

      return colunas.filter(c => this.colunasVisiveis.includes(c.key));
    },

    QuantidadeColunasHierarquia() {
      const colunasAtivas = this.CamposTabelaDinamica;
      return colunasAtivas.filter(c => c.isComercial).length;
    }
  },
  mounted() {
    // Tenta ler o cache gravado localmente antes de montar a listagem
    this.carregarConfiguracoesCache();

    if (this.$route.name != null) {
      this.RelRota = this.$route.name;
      this.PeridoIni = new Date();
      this.PeridoFin = new Date();
      this.MostraReport();
      this.ConsultarOpcoes();
    }
  },
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.header-com-input {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}
.btn-mover {
  cursor: pointer;
  background: #ebebeb;
  border-radius: 3px;
  padding: 0px 5px;
  font-size: 14px;
  font-weight: bold;
  user-select: none;
  color: #5e5873;
  transition: all 0.2s;
}
.btn-mover:hover {
  background: #7367f0;
  color: #fff;
}
.input-filtro {
  width: 100px;
  height: 20px;
  font-size: 11px;
  padding: 2px 4px;
  border: 1px solid #ccc;
  border-radius: 3px;
}
.filter-block {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 1px solid #ddd;
  border-radius: 3px;
  background-color: #f9f9f9;
  cursor: pointer;
}
.filter-block:hover {
  background-color: #e9e9e9;
}
</style>